<h2 class="mt-5 mb-5 titre">Suivis de l'enquête</h2>

<!-- Choisir le suivi enquete permanente ou decision et supprimer le non utile! -->

<!-- Permanente -->
<mat-tab-group class="mt-4" [(selectedIndex)]="suiviSaisieService.ongletIndex">
    <mat-tab class="mat-mdc-tab-header" label="Suivi Général">
        <bis-suivi-general-permanente></bis-suivi-general-permanente>
    </mat-tab>
    <mat-tab class="mat-mdc-tab-header" label="Suivi Détaillé">
        <bis-suivi-detail-permanente></bis-suivi-detail-permanente>
    </mat-tab>
</mat-tab-group>